import type { SensorTypeDto } from '@/features/admin/types/opsExtended.types';

/**
 * Khóa ổn định khớp catalog `/api/sensor-types` ↔ trường `sensor_type` trên trạm.
 * Một số bản API list chỉ trả `id` (UUID), không có `code` slug.
 */
export function sensorTypeCatalogKey(st: Pick<SensorTypeDto, 'code' | 'id'>): string {
  const c = typeof st.code === 'string' ? st.code.trim() : '';
  if (c) return c;
  return typeof st.id === 'string' ? st.id.trim() : '';
}

/** Chuẩn hóa lowercase cho map lookup và visibility (`iotStationTypeVisibility`). */
export function sensorTypeCatalogKeyLower(st: Pick<SensorTypeDto, 'code' | 'id'>): string {
  return sensorTypeCatalogKey(st).toLowerCase();
}
